import * as React from 'react'
import styled from 'styled-components'
import './style.scss'

interface Props {
  text?: string | any
  isChecked?: boolean
  isDisabled?: boolean
  onChange?: (e: any) => void
}

const Wrapper = styled<any>('div')`
  pointer-events: ${props => props.isDisabled && 'none'};
`
const CheckboxContainer = styled<any>('div')`
  background: #ffffff;
  border: 1px solid ${props => (props.isDisabled ? '#B1BED6' : '#BDBDBD')};
`
const CheckMark = styled<any>('span')`
  border: solid ${props => (props.isDisabled ? '#B1BED6' : '#5C8DE8E5')};
`
const Label = styled<any>('span')`
  color: ${props => (props.isDisabled ? '#B1BED6' : '#212121')};
`

export default function CheckBox(props: Props) {
  return (
    <Wrapper className="checkbox-container" onClick={props.onChange} isDisabled={props.isDisabled}>
      <CheckboxContainer isDisabled={props.isDisabled} className="checkbox-container_checkbox">
        {props.isChecked ? <CheckMark isDisabled={props.isDisabled} className="checkbox-container check_mark" /> : null}
      </CheckboxContainer>
      <Label isDisabled={props.isDisabled} className="checkbox-container_text">
        {props.text}
      </Label>
    </Wrapper>
  )
}
